import { IconButton } from '@mui/material';
import { Icons } from 'copyright-clearance-center-common-ui';
import React from 'react';

interface IClearButtonProps {
	onClick: () => void;
	testId?: string;
	className?: string;
}

const ClearButton: React.FC<IClearButtonProps> = ({ onClick, testId, className }) => (
	<IconButton
		onClick={onClick}
		data-test-id={testId}
		className={`rup-search__clear rup-icon-btn rup-icon-btn--neutral rup-icon-btn--xs ${className || ''}`}
		disableRipple
	>
		<span
			dangerouslySetInnerHTML={{ __html: Icons.ClearIcon }}
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center'
			}}
		/>
	</IconButton>
);

export default ClearButton;
